import axios from 'axios';
import onCartUpdate from './onCartUpdate';

async function replaceCartContent() {
  const cartPage = await axios.get('/cart');
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(cartPage.data, 'text/html');

  // Update cart page
  const destinationCartEl = document.getElementById('cart');
  const sourceCartEl = htmlDoc.getElementById('cart');
  if (destinationCartEl && sourceCartEl) destinationCartEl.innerHTML = sourceCartEl.innerHTML;

  // Update cart drawer
  const destinationCartDrawerEl = document.querySelector('#cart-drawer .drawer-content-wrapper');
  const sourceCartDrawerEl = htmlDoc.querySelector('#cart-drawer .drawer-content-wrapper');
  if (destinationCartDrawerEl && sourceCartDrawerEl) destinationCartDrawerEl.innerHTML = sourceCartDrawerEl.innerHTML;

  // Sync data attributes on the desktop relewise recommendations element. It lives
  // outside .drawer-content-wrapper so the innerHTML replacement above does not
  // refresh it — the recommendation request would otherwise run against the
  // pre-add cart state. Attributes are copied instead of replacing the element so
  // any already-rendered recommendation cards are preserved.
  const destinationDesktopRecs = document.querySelector('#cart-drawer relewise-cart-recommendations.desktop-recommendations');
  const sourceDesktopRecs = htmlDoc.querySelector('#cart-drawer relewise-cart-recommendations.desktop-recommendations');
  if (destinationDesktopRecs && sourceDesktopRecs) {
    ['data-product-id', 'data-variant-id', 'data-products-in-cart', 'data-product-types-in-cart', 'data-base-on-free-shipping'].forEach((attr) => {
      const value = sourceDesktopRecs.getAttribute(attr);
      if (value !== null) destinationDesktopRecs.setAttribute(attr, value);
    });
  }

  // Update cart count in header
  const destinationCartCountEl = document.querySelector('.text-cart_count');
  const sourceCartCountEl = htmlDoc.querySelector('.text-cart_count');
  if (destinationCartCountEl && sourceCartCountEl) destinationCartCountEl.replaceWith(sourceCartCountEl);

  // update cart dot in header
  const destinationCartDotEl = document.querySelector('.text-cart_dot');
  const sourceCartDotEl = htmlDoc.querySelector('.text-cart_dot');
  if (destinationCartDotEl && sourceCartDotEl) destinationCartDotEl.replaceWith(sourceCartDotEl);


  // Mirror the persisted membership choice onto the re-rendered toggle + data-wants-member.
  const destinationClubMembershipToggle = destinationCartDrawerEl?.querySelector('#club-membership-toggle');
  if (destinationClubMembershipToggle) {
    const wantsMembership = sessionStorage.getItem('wants_become_club_member') === 'true';
    destinationClubMembershipToggle.checked = wantsMembership;
    const form = destinationCartDrawerEl.querySelector('#cart-form');
    if (form) form.setAttribute('data-wants-member', wantsMembership ? 'true' : 'false');
  }

  onCartUpdate();
}

export default replaceCartContent;
